import React, { useState } from "react";
import RegularButton from "components/CustomButtons/Button"
import { Box } from "@material-ui/core";
import LinkIcon from '@material-ui/icons/Link';
import FileCopyIcon from '@material-ui/icons/FileCopy';

const colors = {
  success: '#4caf50',
  error: '#f6685e',
  info: '#4092E5'
}

export const columnsContracts = [
  {
    Header: 'Contrato',
    accessor: 'name',
    filterable: true,
    filterMethod: (filter, row) => { return row.name.toLowerCase().includes(filter.value.toLowerCase()) },
  },
  {
    Header: 'Fecha de creación',
    accessor: 'date',
    filterable: true,
    filterMethod: (filter, row) => { return row.date.toLowerCase().includes(filter.value.toLowerCase()) },

  },
  {
    Header: 'Acciones',
    Cell: ({ original }) => {
      const [message, setMessage] = useState({
        label: '', color: 'danger'
      })
    
      const copyUrl = () => {
        navigator.clipboard.writeText(original.url).then(() => {
          setMessage({
            ...message, label: `Texto copiado al portapapeles`, color: 'success'
          })
        })
          .catch(err => {
            setMessage({
              ...message, label: `Error al copiar al portapapeles`,
            })
          });
      }
      return (
        <Box style={{ display: 'flex', justifyContent: 'flex-end', }}>
          <RegularButton
            justIcon
            round
            color="transparent"
            tooltip="Copiar"
            size="sm"
            onClick={copyUrl}
          >
            <FileCopyIcon style={{ margin: 0, color: colors.info }} />
          </RegularButton>
          <RegularButton
            justIcon
            round
            color="transparent"
            tooltip="Abrir Pdf"
            size="sm"
            target="_blank"
            href={original.url}
          >
            <LinkIcon style={{ margin: 0, color: colors.success }} />
          </RegularButton>
        </Box>
      )
    }
  }
]